import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';
import { getCapHeadersConfig } from '@app/dashboard/utils/capToken';

export const createSinglePaymentLink = async (payload: FormData) => {
  const capHeaders = await getCapHeadersConfig();
  const headers = {
    'Content-Type': 'multipart/form-data',
    ...capHeaders.headers,
  };

  return axiosPrivate.post('/dashboard/api/v1/payment-links', payload, {
    headers: headers,
  });
};
